<template>
  <div class="oldnew-data-list">
    <!-- 销售经理 一级tabs -->
    <div v-if="$route.query.type == 1" class="tabs-big">
      <div
        :class="{ 'big-active': bigTabsActive === -2 }"
        @click="bigTabsHandle(-2)"
        class="item"
      >
        <div class="top">全部</div>
        <div class="bottom">{{ getAllTotal(totalSale) || 0 }}</div>
      </div>
      <div
        :class="{ 'big-active': bigTabsActive === -5 }"
        @click="bigTabsHandle(-5)"
        class="item"
      >
        <div class="top">客户分配</div>
        <div class="bottom">{{ totalSale["-5"] || 0 }}</div>
      </div>
      <div
        :class="{ 'big-active': bigTabsActive === 3 }"
        @click="bigTabsHandle(3)"
        class="item"
      >
        <div class="top">客户跟进</div>
        <div class="bottom">{{ getSaleFollowsTotal(totalSale) }}</div>
      </div>
      <div
        :class="{ 'big-active': bigTabsActive === 4 }"
        @click="bigTabsHandle(4)"
        class="item"
      >
        <div class="top">客户待审</div>
        <div class="bottom">
          {{ totalSale["pendding"] || 0 }}
        </div>
      </div>
    </div>

    <!--销售经理-客户跟进 二级tabs -->
    <div
      ref="sale_small_wrap"
      v-show="bigTabsActive === 3 && $route.query.type == 1"
      class="tabs-small-wrap"
    >
      <div class="tabs-big tabs-small">
        <div
          :class="{ 'small-active': smallTabsActive === -1 }"
          @click="smallTabsHandle(-1)"
          class="item"
        >
          <div class="top">未处理</div>
          <div class="bottom">{{ totalSale["-1"] || 0 }}</div>
        </div>
        <div
          :class="{ 'small-active': smallTabsActive === 0 }"
          @click="smallTabsHandle(0)"
          class="item"
        >
          <div class="top">未到访</div>
          <div class="bottom">{{ totalSale["0"] || 0 }}</div>
        </div>
        <div
          :class="{ 'small-active': smallTabsActive === 1 }"
          @click="smallTabsHandle(1)"
          class="item"
        >
          <div class="top">已到访</div>
          <div class="bottom">{{ totalSale["1"] || 0 }}</div>
        </div>
        <div
          :class="{ 'small-active': smallTabsActive === 3 }"
          @click="smallTabsHandle(3)"
          class="item"
        >
          <div class="top">已认购</div>
          <div class="bottom">{{ totalSale["3"] || 0 }}</div>
        </div>
        <div
          :class="{ 'small-active': smallTabsActive === 2 }"
          @click="smallTabsHandle(2)"
          class="item"
        >
          <div class="top">已签约</div>
          <div class="bottom">{{ totalSale["2"] || 0 }}</div>
        </div>
        <div
          :class="{ 'small-active': smallTabsActive === 4 }"
          @click="smallTabsHandle(4)"
          class="item"
        >
          <div class="top">已失效</div>
          <div class="bottom">{{ totalSale["4"] || 0 }}</div>
        </div>
      </div>
    </div>
    <!--销售经理-客户待审 二级tabs  -->
    <div v-if="bigTabsActive === 4" class="pending-trial-tabs">
      <div
        @click="changeTrialtabsHandle(-3)"
        :class="{ 'trial-active': penddingTrialActive === -3 }"
      >
        合资待审核
        <br />
        <img
          :src="require('../../../../../common/images/oldnew/under_line.png')"
          alt=""
        />
      </div>
      <div></div>
      <div
        @click="changeTrialtabsHandle(-4)"
        :class="{ 'trial-active': penddingTrialActive === -4 }"
      >
        业主带访
        <br />
        <img
          :src="require('../../../../../common/images/oldnew/under_line.png')"
          alt=""
        />
      </div>
    </div>
    <!-- 置业顾问 tabs-->
    <div
      v-show="$route.query.type == 2"
      ref="adiver_wrap"
      class="tabs-small-wrap "
    >
      <div class="tabs-big tabs-small adviser">
        <div
          :class="{ 'adviser-active': adviserTabsActive === -2 }"
          @click="adviserTabsHandle(-2)"
          class="item"
        >
          <div class="top">全部</div>
          <div class="bottom">{{ totalAdviserAll || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === -1 }"
          @click="adviserTabsHandle(-1)"
          class="item"
        >
          <div class="top">未处理</div>
          <div class="bottom">{{ totalAdviser["-1"] || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === 0 }"
          @click="adviserTabsHandle(0)"
          class="item"
        >
          <div class="top">未到访</div>
          <div class="bottom">{{ totalAdviser["0"] || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === 1 }"
          @click="adviserTabsHandle(1)"
          class="item"
        >
          <div class="top">已到访</div>
          <div class="bottom">{{ totalAdviser["1"] || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === 3 }"
          @click="adviserTabsHandle(3)"
          class="item"
        >
          <div class="top">已认购</div>
          <div class="bottom">{{ totalAdviser["3"] || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === 2 }"
          @click="adviserTabsHandle(2)"
          class="item"
        >
          <div class="top">已签约</div>
          <div class="bottom">{{ totalAdviser["2"] || 0 }}</div>
        </div>
        <div
          :class="{ 'adviser-active': adviserTabsActive === 4 }"
          @click="adviserTabsHandle(4)"
          class="item"
        >
          <div class="top">已失效</div>
          <div class="bottom">{{ totalAdviser["4"] || 0 }}</div>
        </div>
      </div>
    </div>
    <!-- 展示列表 -->
    <div class="container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <!-- tabs为全部展示 -->
        <template
          v-if="
            ($route.query.type == 1 && bigTabsActive === -2) ||
              ($route.query.type == 2 && adviserTabsActive === -2)
          "
        >
          <card
            @checkoutSmall="smallTabsHandle"
            @checkoutBig="bigTabsHandle"
            @checkoutAdviser="adviserTabsHandle"
            v-for="(item, index) in listTotalData"
            :key="index"
            :cardData="item.recommend"
          ></card>
        </template>
        <!-- 客户分配 -->
        <template v-if="bigTabsActive === -5">
          <DistributionItem
            v-for="(item, index) in listTotalData"
            :key="index"
            :distributionItem="item.recommend"
            :noDistributionTime="item.noDistributionTime"
            :distributionIndex="index"
            :projectCode="$route.query.projectCode"
            @initList="refreshHandle"
            :isShowDistribution="isShowDistribution"
          ></DistributionItem>
        </template>
        <!-- 客户跟进 -->
        <template v-if="bigTabsActive === 3">
          <FollowItem
            v-for="(item, index) in listTotalData"
            :key="index"
            :followItem="item.recommend"
            :index="index"
          />
        </template>

        <!--客户待审  -->
        <template v-if="bigTabsActive === 4 && penddingTrialActive === -3">
          <!-- 合资待审 -->
          <JointItem
            v-for="(item, index) in listTotalData"
            :key="index"
            :jointItem="item.recommend"
            :jointIndex="index"
            :categray="'search'"
            :projectCode="$route.query.projectCode"
            :noDisposeTime="item.noDisposeTime"
          ></JointItem>
        </template>
        <!--客户待审  -->
        <template v-if="penddingTrialActive === -4 && bigTabsActive === 4">
          <!-- 业主待访 -->
          <OwnerInfoItem
            v-for="(item, index) in listTotalData"
            :key="index"
            :ownerItem="item.recommend"
            @initList="refreshHandle"
          ></OwnerInfoItem>
        </template>

        <!-- 置业顾问-集合card -->
        <template
          v-if="
            $route.query.type == 2 &&
              adviserTabsActive !== -2 &&
              adviserTabsActive !== 1
          "
        >
          <ProgressCard
            :tabsActive="adviserTabsActive"
            :index="index"
            v-for="(item, index) in listTotalData"
            :key="index"
            :noDisposeTime="item.noDisposeTime"
            :item="item.recommend"
          ></ProgressCard>
        </template>
        <!-- 置业顾问-已到访card -->
        <template v-if="$route.query.type == 2 && adviserTabsActive === 1">
          <ViseitedCard
            :index="index"
            v-for="(item, index) in listTotalData"
            :key="index"
            :item="item.recommend"
          ></ViseitedCard>
        </template>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { List } from "vant";
import { getPositionsByuserId } from "@/api/modules/oldNew.js";

Vue.use(List);
import Card from "./c-list/card";
import FollowItem from "../../FollowComponent/FollowItem";
import DistributionItem from "./c-list/sale/DistributionItem";

import JointItem from "../../PendingComponent/JointItem";
import OwnerInfoItem from "../../PendingComponent/OwnerInfoItem";

import ProgressCard from "./c-list/progressCrad";
import ViseitedCard from "./c-list/adivser/visited";
export default {
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
    totalSale: Object,
    totalAdviser: Object,
  },
  components: {
    Card,
    FollowItem,
    DistributionItem,
    JointItem,
    OwnerInfoItem,
    ProgressCard,
    ViseitedCard,
  },
  mounted() {
    this.$nextTick(() => {
      getPositionsByuserId({}).then((res) => {
        if (res.body.position == 5 || res.body.position == 6) {
          this.isShowDistribution = false;
        }
      });
    });
  },
  watch: {
    totalSale(v) {
      console.log(v, "销售经理统计");
      this.totalSale = v;
    },
    totalAdviser(v) {
      this.totalAdviser = v;
      this.totalAdviserAll = this.adviserAllTotal(this.totalAdviser);
    },
    listData(v) {
      // 去重
      let arr = v.filter(
        (item) =>
          !this.listTotalData.some(
            (_item) => _item.recommend.id === item.recommend.id
          )
      );
      // 分页数据拼接
      this.listTotalData.push(...arr);
    },

    adviserTabsActive(v) {
      // 如果tabs被挡住就改变scrollLeft
      if (v == -1) {
        this.$refs["adiver_wrap"].scrollTo(0, 0);
      } else if (v == 2 || v == 4) {
        this.$refs["adiver_wrap"].scrollLeft = 200;
      }
    },
    smallTabsActive(v) {
      // 如果tabs被挡住就改变scrollLeft
      if (v == -1) {
        this.$refs["sale_small_wrap"].scrollTo(0, 0);
      } else if (v == 4) {
        this.$refs["sale_small_wrap"].scrollLeft = 120;
      }
    },
  },
  data() {
    return {
      finished: false,
      listTotalData: [],
      bigTabsActive: -2,
      loading: false,
      smallTabsActive: -1,
      // 待审状态
      penddingTrialActive: -3,
      adviserTabsActive: -2,
      current: 1,
      status: -2,
      // 是否继续请求
      isGoOn: false,
      // 置业顾问统计-全部
      totalAdviserAll: 0,
      // 是否展示立即分配
      isShowDistribution: true,
    };
  },

  methods: {
    //审核后 刷新统计
    refreshHandle() {
      this.clearTotalArr();
      this.$parent.changeStatusCurrents(1, this.status);
      this.$parent.loadTabsList();
      this.$parent.loadList();
    },
    // 改变客户待审二级菜单Active
    changeTrialActive(num) {
      this.penddingTrialActive = num;
    },
    // 改变客户跟进二级菜单Active
    changeFollowActive(num) {
      this.smallTabsActive = num;
    },
    // 初始化数据
    init() {
      this.finished = false;
      this.listTotalData = [];
      this.bigTabsActive = -2;
      this.loading = false;
      this.smallTabsActive = -1;
      // 待审状态
      this.penddingTrialActive = -3;
      this.adviserTabsActive = -2;
      this.current = 1;
      this.status = -2;
      // 是否继续请求
      this.isGoOn = false;
    },
    // goInfo(info) {
    //   this.$router.push({
    //     name: "oldNewDetail",
    //     query: { id: info.id },
    //   });
    // },
    changeCurrent() {
      // 改变当前页current
      this.current++;
    },
    // 改变finished
    changeFinished() {
      this.finished = true;
    },
    // 改变loading
    closeLoading() {
      this.loading = false;
    },
    // 改变是否继续请求
    changeGoOnStatus() {
      this.isGoOn = true;
    },
    bigTabsHandle(num) {
      if (num === this.bigTabsActive) {
        return;
      }
      this.bigTabsActive = num;
      this.status = num;
      this.current = 1;
      if (num === 3) {
        this.status = this.smallTabsActive;
      } else if (num === 4) {
        this.status = this.penddingTrialActive;
      }
      this.listTotalData = [];
      this.loading = true;
      this.$parent.changeStatusCurrents(this.current, this.status);
      this.finished = false;
      this.onLoad();
    },
    smallTabsHandle(num) {
      if (num === this.smallTabsActive) {
        return;
      }

      this.smallTabsActive = num;
      this.status = num;
      this.current = 1;
      this.listTotalData = [];
      this.loading = true;
      this.$parent.changeStatusCurrents(this.current, this.status);
      this.finished = false;
      this.onLoad();
    },
    adviserTabsHandle(num) {
      if (num === this.adviserTabsActive) {
        return;
      }
      this.adviserTabsActive = num;
      this.status = num;
      this.current = 1;
      this.listTotalData = [];
      this.loading = true;
      this.$parent.changeStatusCurrents(this.current, this.status);
      this.finished = false;
      this.onLoad();
    },
    changeTrialtabsHandle(num) {
      this.penddingTrialActive = num;
      this.status = num;
      this.current = 1;
      this.listTotalData = [];
      this.loading = true;
      this.$parent.changeStatusCurrents(this.current, this.status);
      this.finished = false;
      this.onLoad();
    },
    onLoad() {
      if (this.isGoOn) {
        this.$parent.changeStatusCurrents(this.current, this.status);
        this.$parent.loadList();
      }
    },
    // 获取销售经理跟进全部
    getSaleFollowsTotal(totalSale) {
      let num = 0;
      num =
        (totalSale["-1"] || 0) +
        (totalSale["0"] || 0) +
        (totalSale["1"] || 0) +
        (totalSale["2"] || 0) +
        (totalSale["3"] || 0) +
        (totalSale["4"] || 0);

      return num;
    },
    // 获取销售经理全部统计
    getAllTotal(totalSale) {
      let num = 0;

      num =
        (totalSale["-1"] || 0) +
        (totalSale["0"] || 0) +
        (totalSale["1"] || 0) +
        (totalSale["2"] || 0) +
        (totalSale["3"] || 0) +
        (totalSale["4"] || 0) +
        (totalSale["-5"] || 0) +
        (totalSale["pendding"] || 0);

      return num;
    },
    // 获取置业顾问全部统计
    adviserAllTotal(totalAdviser) {
      console.log(totalAdviser, "置业顾问全部统计");
      let num = 0;
      num =
        (totalAdviser["-1"] || 0) +
        (totalAdviser["0"] || 0) +
        (totalAdviser["1"] || 0) +
        (totalAdviser["2"] || 0) +
        (totalAdviser["3"] || 0) +
        (totalAdviser["4"] || 0);

      return num;
    },
    clearTotalArr() {
      this.listTotalData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.oldnew-data-list {
  font-family: PingFangSC-Medium, PingFang SC;
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  .tabs-big {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 30px;
    .item {
      width: 156px;
      height: 104px;
      background: #ffffff;
      box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
      border-radius: 16px;
      color: #333333;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      .top {
        font-size: 28px;
        line-height: 40px;
      }
      .bottom {
        font-size: 24px;
        line-height: 34px;
      }
    }
    .big-active {
      background: linear-gradient(317deg, #e8ad44 0%, #e9c55b 100%);
      box-shadow: 0px 4px 12px 0px rgba(233, 191, 83, 0.4);
      color: #ffffff;
    }
    .small-active {
      background: #0d9869;
      box-shadow: 0px 0px 4px 0px rgba(13, 152, 105, 0.4);
      color: #ffffff;
    }
    .adviser-active {
      background: linear-gradient(317deg, #e8ad44 0%, #e9c55b 100%);
      box-shadow: 0px 4px 12px 0px rgba(233, 191, 83, 0.4);
      color: #ffffff;
    }
  }
  .tabs-small-wrap {
    width: 100%;
    overflow-y: hidden;
    padding-bottom: 20px;
  }

  .tabs-small {
    margin-top: 24px;

    .item {
      min-width: 116px;
      margin-right: 22px;
    }
  }
  .pending-trial-tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    width: 100%;
    text-align: center;

    background: #f7f7f7;
    font-weight: 400;
    line-height: 80px;
    div {
      height: 100%;
      position: relative;
      img {
        width: 50px;
        height: 14px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
        display: none;
      }
    }
    div:nth-child(1) {
      flex: 1;
    }
    div:nth-child(2) {
      width: 2px;
      height: 32px;
      background: #d8d8d8;
      border-radius: 1px;
    }
    div:nth-child(3) {
      flex: 1;
    }
    .trial-active {
      color: #0d9869;
      font-weight: 500;
      text-align: center;

      img {
        display: block;
      }
    }
  }
  .adviser {
    margin-top: 0;
  }
  .container {
    flex: 1;
    overflow-x: hidden;
    margin-top: 30px;
    padding: 0 30px;
  }
}
</style>
